<template>
  <fieldset>
    <BusinessEntityIsVatRegistered
      v-model="isVatRegistered"
      :disabled="disabled"
      :market="market"
      name="is_vat_registered"
    />
    <div v-if="isVatRegistered && !hideVatNoInput" class="tw-my-2">
      <BusinessEntityInput
        v-if="isVatRegistered"
        v-model="vatNo"
        :disabled="disabled"
        :label="labelVat"
        name="vat_no"
        required
      />
      <WdsTag v-if="taxValidationStatus === 'valid'" success class="tw-mt-1">
        {{ $t('VAT valid') }}
      </WdsTag>
      <WdsTag v-else-if="taxValidationStatus === 'invalid'" error class="tw-mt-1">
        {{ $t('VAT invalid') }}
      </WdsTag>
    </div>

    <BusinessEntityVatChangeAlert
      v-if="vatRegisteredIsChanged && complianceData.doesNotHaveEmptyBill"
    />
  </fieldset>
</template>

<script>
import { computed, ref, watch } from 'vue'
import { WdsTag } from '@worksome/wds-components'
import BusinessEntityIsVatRegistered from '@/components/compliances/BusinessEntity/BusinessEntityIsVatRegistered.vue'
import BusinessEntityInput from '@/components/compliances/BusinessEntity/BusinessEntityInput.vue'
import BusinessEntityVatChangeAlert from '@/components/compliances/BusinessEntity/BusinessEntityVatChangeAlert.vue'
import { useMarketDependentValue } from '@/composables/markets'

export default {
  components: {
    BusinessEntityInput,
    BusinessEntityIsVatRegistered,
    BusinessEntityVatChangeAlert,
    WdsTag,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
    complianceData: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    market: {
      type: String,
      default: null,
    },
  },
  emits: ['update:businessEntity', 'update:isVatRegistered'],
  setup(props, { emit }) {
    const taxValidationStatus = computed(
      () => props.businessEntity.data?.tax_validation_status ?? null,
    )

    const isVatRegistered = ref(
      props.businessEntity.taxNo !== null && props.businessEntity.taxNo !== '',
    )
    const isVatRegisteredOrig = ref(isVatRegistered.value)
    const vatRegisteredIsChanged = computed(
      () => isVatRegistered.value === isVatRegisteredOrig.value,
    )

    const internalBusinessEntity = ref(props.businessEntity)
    const vatNo = computed({
      get() {
        return props.businessEntity.taxNo
      },
      set(value) {
        internalBusinessEntity.value.taxNo = value
        emit('update:businessEntity', internalBusinessEntity.value)
      },
    })

    const hideVatNoInput = computed(() => props.market === 'DE')
    watch(isVatRegistered, (value) => {
      emit('update:isVatRegistered', value)
      if (hideVatNoInput.value) {
        vatNo.value = value ? internalBusinessEntity.value.companyNo : null
      }
    })

    emit('update:isVatRegistered', isVatRegistered.value)

    const { marketValue: labelVat } = useMarketDependentValue(
      props.market,
      {
        AU: $t('GST number'),
        SG: $t('GST number'),
      },
      $t('VAT number'),
    )

    return {
      hideVatNoInput,
      isVatRegistered,
      isVatRegisteredOrig,
      labelVat,
      taxValidationStatus,
      vatNo,
      vatRegisteredIsChanged,
    }
  },
}
</script>
